<template>
  <div class="col" :class="_cols">
    <slot></slot>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
// PROPS
const props = defineProps({
  cols: String   
})

// computed
const _cols = computed(() => props.cols ? "col-" + props.cols ?? "": "")


</script>
